





























































import Vue from 'vue'

interface Field {
  function: string
  field: string
  alias: string
}

export default Vue.extend({
  name: 'FieldsEditor',
  props: {
    query: String,
  },

  data() {
    return {
      optsFunction: [
        'count',
        'integral',
        'mean',
        'median',
        'mode',
        'sum',
        'min',
        'max',
        'custom',
      ],
      expandList: false,
      fields: [] as Field[],
    }
  },

  methods: {
    addField() {
      this.fields.push({ function: 'mean', field: 'value', alias: 'nilai' })
    },
    deleteField(index: number) {
      this.fields.splice(index, 1)
    },
    stringifyField() {
      const query = this.fields.map((field) => {
        if (field.function != 'custom') {
          return `${field.function}("${field.field}") as "${field.alias}"`
        }
        return `(${field.field}) as ${field.alias}`
      })

      this.$emit('update:query', query.join(','))
    },

    parseField() {
      this.fields = this.query
        .split(',')
        .map((f: string) => {
          if (f.trim()[0] == '(') {
            const q = f.split(/ as /gi).map((e) => e.trim())
            q[0] = q[0].substring(1, q[0].length - 1)
            return ['custom', ...q]
          }

          return f
            .replace(/[")]/g, '')
            .replace(/ as /gi, ',')
            .replace(/\(/g, ',')
            .replace(/, /g, ',')
            .replace(/ ,/g, ',')
            .split(',')
        })
        .map((q: string[]) => {
          return {
            function: q[0],
            field: q[1],
            alias: q[2],
          }
        })
    },
  },

  watch: {
    fields: {
      deep: true,
      handler: function() {
        this.stringifyField()
      },
    },
    query: function() {
      this.parseField()
    },
  },

  created() {
    this.parseField()
  },
})
